import { useLang } from 'hooks/lang';

import { EntitySelect } from 'components/Entities';

import { Client, loaders } from 'entities';

interface Props {
  client: string;
  setClient: (newClient: string) => void;
  showOnlyActive: boolean;
  onLoad?: (clients: Client[]) => void;
}

function ClientSelect({ client, setClient, showOnlyActive, onLoad }: Props): JSX.Element {
  const { t } = useLang();

  const balanceOverview = loaders.clients.balanceOverview.use();

  return (
    <EntitySelect
      id="client"
      labelKey="name"
      target="clients.list"
      label={t('client')!}
      value={client}
      onChangeDirect={setClient}
      filter={showOnlyActive ? ({ id }) => balanceOverview?.data?.clients?.includes(id) : undefined}
      onLoad={onLoad}
    />
  );
}

export default ClientSelect;
